import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { ORGANIZATIONS_KEY } from './keys';
import { EventApi } from 'api';

function useGetOrganizations(id: number) {
  return useAuthQuery(
    getQueryKeys(ORGANIZATIONS_KEY).detail(id),
    () => EventApi.getOrganizations(id),
    {
      select: (data) => data.data,
      enabled: !!id,
    },
  );
}

export default useGetOrganizations;
